import "./App.css";
import Intro from "./components/header/Intro";
import Nav from "./components/nav/Nav";
import About from "./components/about/About";
import Experience from "./components/experience/Experience";
// import Services from "./components/services/Services";
// import Portfolio from "./components/portfolio/Portfolio";
// import Testimonials from "./components/testimonials/Testimonials";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import WorkExperience from "./components/workexperience/WorkExperience";
import PersonalProjects from "./components/personalprojects/PersonalProjects";
import Divider from "./components/divider/Divider";

function App() {
  return (
    <>
      <Intro />
      <Nav />
      <Divider />
      <WorkExperience />
      <PersonalProjects />
      <Experience />
      <About />
      {/* <Services />
      <Portfolio />
      <Testimonials /> */}
      <Contact />
      <Footer />
    </>
  );
}

export default App;
